export const reportDetailedNotesTypes = {
  SET_DETAILED_NOTES_FILTERS: 'SET_DETAILED_NOTES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL'
};
